import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET008_Request as InfoRequest,
  IAPI_RET008_Response as InfoResponse,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 退職手当金振込先金融機関変更届参照
// API仕様書_退職者
const httpAPI_RET008 = async (param: InfoRequest): Promise<InfoResponse> => {
  let res = await http.post(ApiUrl.API_RET008, {
    ...param,
  });
  return res.data;
};

// 申請状況更新
// API仕様書_退職者
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });
  return res.data;
};

export { httpAPI_RET008, httpAPI_APP016 };
